import AutorenewIcon from '@mui/icons-material/Autorenew';
import MailIcon from '@mui/icons-material/Mail';
import MarkEmailUnreadIcon from '@mui/icons-material/MarkEmailUnread';
import PendingIcon from '@mui/icons-material/Pending';
import { Chip } from '@mui/material';
import React from 'react';

const MessageStatusIcon = (props) => {
  const { status } = props;

  if (status?.code === 'DRAFT') {
    return (
      <Chip
        icon={<PendingIcon />}
        label={status?.name}
        color={'error'}
        size="small"
      />
    );
  } else if (status?.code === 'TOSEND') {
    return (
      <Chip
        icon={<PendingIcon />}
        label={status?.name}
        color={'primary'}
        size="small"
      />
    );
  } else if (status?.code === 'SENDING') {
    return (
      <Chip
        icon={<AutorenewIcon />}
        label={status?.name}
        color={'info'}
        size="small"
      />
    );
  } else if (status?.code === 'RECEIVED') {
    return (
      <Chip
        icon={<MarkEmailUnreadIcon />}
        label={status?.name}
        color={'warning'}
        size="small"
      />
    );
  } else if (status?.code === 'SENT') {
    return (
      <Chip
        icon={<MailIcon />}
        label={status?.name}
        color={'success'}
        size="small"
      />
    );
  } else {
    return (
      <Chip
        icon={<PendingIcon />}
        label={status?.name}
        color={'default'}
        size="small"
      />
    );
  }
};

export default MessageStatusIcon;
